import { computed, makeObservable } from 'mobx'
import type moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'
import { Model } from 'modules/core/lib/mobx-rest'

interface IObservation {
  [key: string]: any
}

class Observation extends Model<IObservation> {
  constructor(attr: IObservation = {}) {
    super(attr)
    makeObservable(this, {
      effectiveOn: computed,
    })
  }

  static urlRoot() {
    return '/handoffs/observations'
  }

  get effectiveOn(): moment.Moment {
    return stringToDate(this.attributes.effective_on, 'backend')
  }
}

export default Observation
